import * as React from 'react';

const LoadingIcon = ({ size, color = '#ffffff' }: { size: number; color?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
    >
      <circle
        cx="9.89581"
        cy="9.89581"
        r="8.89581"
        stroke={color}
        strokeOpacity="0.8"
        strokeWidth="2"
      />
      <path
        d="M18.7701 10.4376C19.3241 10.4715 19.806 10.049 19.7835 9.4944C19.7406 8.43906 19.529 7.39515 19.1547 6.40289C18.6618 5.09649 17.8981 3.90917 16.9137 2.91897C15.9293 1.92876 14.7465 1.15809 13.443 0.657593C12.1395 0.157097 10.7448 -0.0618892 9.35069 0.0150256C7.95654 0.0919404 6.59444 0.463015 5.35392 1.10386C4.1134 1.74471 3.02254 2.64082 2.15303 3.73331C1.28352 4.82579 0.65504 6.08992 0.3089 7.4426C0.0459919 8.47003 -0.0495139 9.53087 0.0239941 10.5845C0.0626212 11.1382 0.588031 11.5051 1.13493 11.4106C1.68184 11.316 2.04173 10.7953 2.01745 10.2409C1.98362 9.46845 2.06349 8.69341 2.25606 7.94086C2.5319 6.86292 3.03273 5.85554 3.72563 4.98495C4.41854 4.11435 5.28784 3.40025 6.27641 2.88956C7.26497 2.37887 8.35041 2.08316 9.4614 2.02187C10.5724 1.96058 11.6838 2.13509 12.7225 2.53393C13.7613 2.93277 14.7038 3.54692 15.4883 4.33601C16.2728 5.12509 16.8814 6.07126 17.2741 7.11232C17.5483 7.83911 17.713 8.60067 17.7643 9.37211C17.8012 9.92591 18.2162 10.4038 18.7701 10.4376Z"
        fill="url(#paint0_linear_901_1587)"
      >
        <animateTransform
          attributeName="transform"
          dur="1s"
          from="0 10 10"
          repeatCount="indefinite"
          to="360 10 10"
          type="rotate"
        ></animateTransform>
      </path>
      <defs>
        <linearGradient
          id="paint0_linear_901_1587"
          x1="19.7916"
          y1="9.89581"
          x2="0.989581"
          y2="11.3802"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3B49FF" />
          <stop offset="1" stopColor="#3B49FF" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LoadingIcon;
